import {
  ChangeEvent,
  useId,
  useRef,
  useState,
  MouseEvent,
  KeyboardEvent,
} from 'react';
import styles from './ListItem.module.scss';
import { ListItemContent } from './ListItemContent';

interface Props {
  description?: string;
  name?: string;
  onClick?: () => void;
  seleced?: boolean;
  title: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function ListboxItem(props: Props) {
  const [selected, setSelected] = useState(props.seleced ?? false);
  const checkboxRef = useRef<HTMLInputElement>(null);
  const id = useId();
  const rootClassNames = [styles['list-item'], styles['list-item-pressable']]
    .filter(Boolean)
    .join(' ');

  const onClick = () => {
    checkboxRef.current?.click();
    props.onClick?.();
  };
  const onLiKeydown = (event: KeyboardEvent<HTMLLIElement>) => {
    switch (event.key) {
      case 'Enter':
      case ' ':
        checkboxRef.current?.click();
        break;

      default:
        break;
    }
  };

  const onCheckboxClick = (event: MouseEvent<HTMLInputElement>) => {
    event.stopPropagation();
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelected(event.currentTarget.checked);
    props.onChange?.(event);
  };

  return (
    <li
      aria-labelledby={id}
      aria-selected={selected}
      className={rootClassNames}
      onClick={onClick}
      onKeyDown={onLiKeydown}
      role="option"
      tabIndex={0}
    >
      <div className={styles['list-addon-start']}>
        <input
          ref={checkboxRef}
          aria-hidden={true}
          className={styles['list-checkbox-input']}
          name={props.name}
          onChange={onChange}
          onClick={onCheckboxClick}
          tabIndex={-1}
          type="checkbox"
        />
      </div>
      <ListItemContent description={props.description} title={props.title} />
    </li>
  );
}
